/**
 * 私聊：邀请提示条 + 会话横幅。
 *
 * 对应老系统 MSGKEY_PMINVITE / PMINVITERET / PMSTOP 一组消息。
 * 老客户端把私聊做成一个独立弹窗，上课时很容易被主窗口挡住而错过；
 * 这里改成教室内的横幅与提示，不抢焦点也不会被盖住。
 *
 * 私聊内容本身仍走 text.send 的悄悄话（secret=true），
 * 因此消息记录与公开发言在同一个交流区里按标记区分，
 * 不必再维护第二套消息列表。
 */

import { useRoomStore } from '../stores/roomStore'

export function PrivateChat() {
  const members = useRoomStore((s) => s.members)
  const pmPeer = useRoomStore((s) => s.pmPeer)
  const pmInvites = useRoomStore((s) => s.pmInvites)
  const replyPM = useRoomStore((s) => s.replyPM)
  const stopPM = useRoomStore((s) => s.stopPM)

  const invites = [...pmInvites.entries()]
  if (invites.length === 0 && pmPeer < 0) return null

  return (
    <div className="pm-area">
      {invites.map(([fromId, text]) => (
        <div key={fromId} className="pm-invite">
          <span className="pm-text">
            <strong>{members.get(fromId)?.name ?? `席位 ${fromId}`}</strong> 想和你私聊
            {text && <em>：{text}</em>}
          </span>
          <span className="pm-ops">
            <button className="mini primary" onClick={() => replyPM(fromId, true)}>
              接受
            </button>
            <button className="mini" onClick={() => replyPM(fromId, false)}>
              谢绝
            </button>
          </span>
        </div>
      ))}

      {pmPeer >= 0 && (
        <div className="pm-active">
          <span className="pm-text">
            正在与 <strong>{members.get(pmPeer)?.name ?? `席位 ${pmPeer}`}</strong> 私聊
            <em>—— 在交流区选中他即可悄悄说话</em>
          </span>
          <button className="mini" onClick={stopPM}>
            结束私聊
          </button>
        </div>
      )}
    </div>
  )
}
